import { FC, useState } from "react";

import { Button } from "antd";

import EditCollection from "../EditCollection";

const NewRecherche: FC = () => {
  const [recherche, setRecherche] = useState<any>(undefined);

  return (
    <>
      <Button type="primary" onClick={() => setRecherche({})}>
        Créer recherche
      </Button>

      <EditCollection
        editItem={recherche}
        mode="create"
        onCloseEdit={() => setRecherche(undefined)}
      />
    </>
  );
};

export default NewRecherche;
